import { render, staticRenderFns } from "./SummaryRow.vue?vue&type=template&id=38bfa5e1&"
import script from "./SummaryRow.vue?vue&type=script&lang=js&"
export * from "./SummaryRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports